/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Ai_DraftInputs */

const en_us2_coaching_ai_draft = /** @type {(inputs: Coaching_Ai_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask the AI for a draft`)
};

const pt_br2_coaching_ai_draft = /** @type {(inputs: Coaching_Ai_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedir à IA um rascunho`)
};

const pt_pt2_coaching_ai_draft = /** @type {(inputs: Coaching_Ai_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedir à IA um rascunho`)
};

/** @type {(inputs: Coaching_Ai_DraftInputs) => LocalizedString} */
const es_419_coaching_ai_draft = en_us2_coaching_ai_draft;

/** @type {(inputs: Coaching_Ai_DraftInputs) => LocalizedString} */
const fr_fr2_coaching_ai_draft = en_us2_coaching_ai_draft;

/** @type {(inputs: Coaching_Ai_DraftInputs) => LocalizedString} */
const de_de2_coaching_ai_draft = en_us2_coaching_ai_draft;

/** @type {(inputs: Coaching_Ai_DraftInputs) => LocalizedString} */
const it_it2_coaching_ai_draft = en_us2_coaching_ai_draft;

/**
* | output |
* | --- |
* | "Ask the AI for a draft" |
*
* @param {Coaching_Ai_DraftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_ai_draft = /** @type {((inputs?: Coaching_Ai_DraftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Ai_DraftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_ai_draft(inputs)
	if (locale === "es-419") return es_419_coaching_ai_draft(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_ai_draft(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_ai_draft(inputs)
	if (locale === "de-DE") return de_de2_coaching_ai_draft(inputs)
	if (locale === "it-IT") return it_it2_coaching_ai_draft(inputs)
	return en_us2_coaching_ai_draft(inputs)
});
export { coaching_ai_draft as "coaching.ai_draft" }